import React, { useState } from "react";
import Slider from "react-slick";

function DateSelectField(): JSX.Element {
  const [selectedDate, setSelectedDate] = useState<string>("");

  // Generate an array of 5 dates starting from today's date, with day names
  const dates: { date: string; dayName: string }[] = [];
  for (let i = 0; i < 365; i++) {
    const date: Date = new Date();
    date.setDate(date.getDate() + i);
    const dayName: string = date.toLocaleString("en-US", { weekday: "short" });
    const dateString: string = date.toISOString().substring(0, 10);
    dates.push({ date: dateString, dayName: dayName });
  }
  console.log(dates);
  // Handle changes to the selected date
  function handleDateChange(event: React.ChangeEvent<HTMLInputElement>): void {
    setSelectedDate(event.target.value);
  }
  // slider functions and buttons custom
  const PreviousBtn = (props: any) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <svg width="32" height="25" viewBox="0 0 32 25">
          <path
            fill="#ef5366"
            fillRule="evenodd"
            d="M0 12a1.22 1.22 0 0 1 0-.13v-.11a1.25 1.25 0 0 1 0-.13l.05-.1.07-.12.07-.09.08-.1L11 .39a1.3 1.3 0 0 1 1.82 0 1.25 1.25 0 0 1 0 1.79l-8.43 8.56h26.32a1.3 1.3 0 0 1 0 2.59H4.29l8.55 8.55a1.25 1.25 0 0 1 0 1.79 1.3 1.3 0 0 1-1.82 0L.37 13l-.08-.09-.08-.09-.06-.11-.06-.11a1.18 1.18 0 0 1 0-.12 1.22 1.22 0 0 1 0-.12 1.16 1.16 0 0 1 0-.12 1.2 1.2 0 0 1 0-.13L0 12z"
          ></path>
        </svg>
      </div>
    );
  };
  const NextBtn = (props: any) => {
    const { className, onClick } = props;
    return (
      <div className={className} onClick={onClick}>
        <svg width="32" height="25" viewBox="0 0 32 25">
          <path
            fill="#ef5366"
            fillRule="evenodd"
            d="M32 12a1.22 1.22 0 0 0 0-.13v-.11a1.25 1.25 0 0 0 0-.13l-.05-.1-.07-.12-.07-.09-.08-.1L21 .39a1.3 1.3 0 0 0-1.82 0 1.25 1.25 0 0 0 0 1.79l8.43 8.56H1.29a1.3 1.3 0 0 0 0 2.59h26.42l-8.55 8.55a1.25 1.25 0 0 0 0 1.79 1.3 1.3 0 0 0 1.82 0L31.63 13l.08-.09.08-.09.06-.11.06-.11a1.18 1.18 0 0 0 0-.12 1.22 1.22 0 0 0 0-.12 1.16 1.16 0 0 0 0-.12 1.2 1.2 0 0 0 0-.13L32 12z"
          ></path>
        </svg>
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    nextArrow: <NextBtn />,
    prevArrow: <PreviousBtn />,
    responsive: [
      {
        breakpoint: 1270,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
    <div className="date-select-field-container">
      <div className="date-select-field-scrollable">
        <Slider {...settings}>
          {dates.map(({ date, dayName }) => (
            <label key={date} className="appointmentCircle">
              <input
                type="radio"
                name="date"
                value={date}
                checked={selectedDate === date}
                onChange={handleDateChange}
              />
              <div>{dayName}</div>
              <div>{date}</div>
            </label>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default DateSelectField;
